module.exports = __webpack_public_path__ + "static/media/light-moderate.5c554fc8.png";